export const SubscriptionPlan = {
  FREE: 'free',
  PRO: 'premium',
  ENTERPRISE: 'enterprise',
}

export const FEATURE_KEYS = {
  COLLECTIONS: 'collections',
  FULL_RES_SCREENSHOT: 'full_res_screen_shot',
  PUBLIC_SHARING: 'public_sharing',
  PREMIUM_ASSETS: 'premium_assets',
}

export type FeatureKey = (typeof FEATURE_KEYS)[keyof typeof FEATURE_KEYS]
export const FEATURES_MAP: Record<
  FeatureKey | 'default',
  { label: string; free: boolean; pro: boolean; enterprise: boolean; toastMessage: string }
> = {
  [FEATURE_KEYS.COLLECTIONS]: {
    label: 'Collections',
    free: true,
    pro: true,
    enterprise: true,
    toastMessage: 'Please upgrade to premium for collections',
  },

  [FEATURE_KEYS.FULL_RES_SCREENSHOT]: {
    label: 'Full Resolution Screenshot',
    free: false,
    pro: true,
    enterprise: true,
    toastMessage: 'Please upgrade to premium for full resolution screenshots',
  },

  [FEATURE_KEYS.PUBLIC_SHARING]: {
    label: 'Public Sharing',
    free: false,
    pro: true,
    enterprise: true,
    toastMessage: 'Please upgrade to premium for public sharing',
  },

  [FEATURE_KEYS.PREMIUM_ASSETS]: {
    label: 'Premium Assets',
    free: false,
    pro: true,
    enterprise: true,
    toastMessage: 'Please upgrade to premium for premium assets',
  },
}
